export type WlodevAnalyticsConfig = {}

export const getInjectableAnalyticsContent = async ({
    mode,
}: {
    mode: 'development' | 'production'
}) => {
    if (mode === 'development') {
        // TODO: Enable debug mode
        return ``
    }

    return `
	    var script = document.createElement('script');
		script.defer = true;
		script.src = '/_wlodev/analytics/script.js';
        script.setAttribute('data-website-id', 'wlodev');
		var head = document.querySelector('head');
		head.appendChild(script);
	`
}
